import React from 'react'
import Header from "../../components/header/index";
// import TermConditionContent from './termsconditioncontent/termConditionContent';
import Footer from "../../components/footer";
import HelpContent from './helpcontent/helpContent';


const help = () => {
  return (
    <div className="main">
    <Header />
    <HelpContent />
    {/* <TermConditionContent /> */}
    <Footer />
</div>
  )
}

export default help